export type CalendarDate = {
  year: number;
  month: number; // 0-11
  day: number;
};

export function parseDate(
  value: string | null | undefined,
): CalendarDate | null {
  if (!value) {
    return null;
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);

  if (!match) {
    return null;
  }

  return {
    year: Number(match[1]),
    month: Number(match[2]) - 1,
    day: Number(match[3]),
  };
}

export function formatDate({ year, month, day }: CalendarDate): string {
  return [
    String(year).padStart(4, "0"),
    String(month + 1).padStart(2, "0"),
    String(day).padStart(2, "0"),
  ].join("-");
}

export function today(): CalendarDate {
  const now = new Date();

  return { year: now.getFullYear(), month: now.getMonth(), day: now.getDate() };
}

export function compareDate(a: CalendarDate, b: CalendarDate): number {
  if (a.year !== b.year) {
    return a.year - b.year;
  }

  if (a.month !== b.month) {
    return a.month - b.month;
  }

  return a.day - b.day;
}

export function daysInMonth(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

export function addMonths(
  year: number,
  month: number,
  delta: number,
): { year: number; month: number } {
  const total = year * 12 + month + delta;

  return { year: Math.floor(total / 12), month: ((total % 12) + 12) % 12 };
}
